import React, { useState } from "react";
import styles from './ImageRenderr.module.scss'

const ImageRenderr = ({
  src,
  alt = "",
  width = "100%",
  height = "100%",
  styleClass = "",
  style = {},
  skeletonClass = "",
  onIcnClick,
  fetchImgPriority,
  loadingType="lazy",
  showSkeleton=true
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleOnLoad = () => {
    setLoading(false)
  }

  const handleOnError = () => {
    setLoading(false);
    setError(true);
  }

  const handleIcnClick = () => {
    onIcnClick?.()
  }
  return (
    <div
      onClick={handleIcnClick}
      className={`${styleClass}`}
      style={{ width, height, position: "relative", ...style }}
    >
      {
        loading && !error && showSkeleton ?
          <div className={`${styles["skeleton"]} ${skeletonClass}`} /> : null
      }

      {!(error) && (
        <img
          src={src}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loading ? 0 : 1
          }}
          onLoad={handleOnLoad}
          onError={handleOnError}
          fetchpriority={fetchImgPriority}
          loading={loadingType}
        />
      )}
    </div>
  );
};

export default ImageRenderr